// The tutorial registry: every tutorial in one list, and the lookups the engine, the `?` button, the Tutorials page and
// the gate (scripts/check-tutorials.mjs) share. Plain data — node loads this file directly for the gate.
import { TIER1 } from "./tier1";
import { TIER2 } from "./tier2";
import { TIER3 } from "./tier3";
import type { Area, Surface, Tutorial } from "./types";

export * from "./types";

export const TUTORIALS: readonly Tutorial[] = [...TIER1, ...TIER2, ...TIER3];

const BY_ID = new Map(TUTORIALS.map((t) => [t.id, t]));

export const tutorial = (id: string): Tutorial | undefined => BY_ID.get(id);
export const hasTutorial = (id: string): boolean => BY_ID.has(id);

/** Tier-3 tutorials under an area's tier-2 tutorial, in registry order. */
export const childrenOf = (parentId: string): Tutorial[] => TUTORIALS.filter((t) => t.parent === parentId);

export const byTier = (tier: 1 | 2 | 3): Tutorial[] => TUTORIALS.filter((t) => t.tier === tier);
export const byArea = (area: Area): Tutorial[] => TUTORIALS.filter((t) => t.area === area);

/**
 * The tier-1 tutorial that should begin by itself on this surface for a first-timer, on this kind of screen.
 * `phone` picks the phone variant when one exists for the surface; a tutorial with `phone` unset fits either.
 */
export function autoStartTutorial(surface: Surface, phone: boolean): Tutorial | null {
  const here = TUTORIALS.filter((t) => t.tier === 1 && t.autoStart === surface);
  return here.find((t) => t.phone === phone) ?? here.find((t) => t.phone === undefined) ?? null;
}
